import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { white, link } from 'styles/colors'
import { title, header2, header3 } from 'styles/texts'
import {
  consultantExperienceIdsSelector,
  experienceTimeSelector,
  isSelfSelector,
  isAdminSelector,
  queryStringSelector,
} from 'selectors'

import Project from './Project'
import EditExperience from 'components/EditExperience'
import ModalButton from 'components/ModalButton'

const Wrapper = styled.div``

const Header = styled.div`
  padding: 20px 30px;
  background-color: ${white};
  border-radius: 4px;
  ${header3};
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Heading = styled.div`
  ${header2};
`

const AddExperienceButton = styled.button`
  ${title};
  cursor: pointer;
  color: ${link};
  margin-top: 8px;
  padding: 20px 30px;
  background-color: ${white};
  border-radius: 4px;
  display: flex;
  align-items: center;
  border: none;
  width: 100%;
  text-decoration: none;
`

const Plus = styled.div`
  font-size: 20px;
  margin-right: 8px;
`

const Experience = ({
  className,
  experienceIds,
  experienceTime,
  isSelf,
  isAdmin,
  consultantId,
  queryString,
}) => (
  <Wrapper className={className}>
    <Header>
      <Heading>Erfaring</Heading>
      {/*<div>
        {(isSelf || isAdmin) && (
          <EditModalButton
            title="Endre erfaring"
            renderForm={props => (
              <EditConsultantStartDate {...props} consultantId={consultantId} />
            )}
          />
        )}
        {experienceTime}
      </div>*/}
    </Header>
    {(isSelf || isAdmin) && (
      <ModalButton
        title="Ny erfaring"
        renderButton={props => (
          <AddExperienceButton {...props}>
            <Plus>+</Plus>
            <div>Legg til erfaring</div>
          </AddExperienceButton>
        )}
        renderModal={props => (
          <EditExperience {...props} consultantId={consultantId} />
        )}
      />
    )}
    {experienceIds.map((experienceId, i) => (
      <Project
        key={i}
        consultantId={consultantId}
        experienceId={experienceId}
      />
    ))}
  </Wrapper>
)

const mapStateToProps = (state, { consultantId }) => ({
  consultantId,
  experienceIds: consultantExperienceIdsSelector(state, consultantId) || [],
  experienceTime: experienceTimeSelector(state, consultantId),
  isSelf: isSelfSelector(state, consultantId),
  queryString: queryStringSelector(state),
  isAdmin: isAdminSelector(state),
})

export default connect(mapStateToProps)(Experience)



// WEBPACK FOOTER //
// ./src/components/Consultant/Experience/index.js